import React, { useState, useEffect } from "react";
import axios from "axios";
import { baseUrl, getDateWithDay } from "../../comman/config.js";
import { VegRequirementFilter } from "../../components/Filter/VegRequirementFilter.js";
import toast, { Toaster } from "react-hot-toast";
import { ChevronUpIcon, ChevronDownIcon } from "@heroicons/react/solid";
import IssueModal from "../../components/IssueModal.js";
import Select from 'react-select';
import Loader from "../../components/Loader.js";
import NoRecordsFound from "../../components/NoRecordsFound.js";
import { saveAs } from 'file-saver';
import * as XLSX from 'xlsx';

// import Pagination from "react-js-pagination";

function IssueNetList() {
  const today = new Date().toISOString().split("T")[0];
  const [requirementList, setRequirementList] = useState([]);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [selectAll, setSelectAll] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [session, setSession] = useState([]);
  const [netIssueStatus, setNetIssueStatus] = useState([]);
  const [item, setItem] = useState([]);
  const [kit,setKit] = useState({})
  const [kitList,setKitList] = useState([])
  const [showModal, setShowModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [itemIngredientList, setItemIngredientList] = useState([]);
  const [methodList, setMethodList] = useState([]);
  const [ingredientList, setIngredientList] = useState([]);
  const [loading, setLoading] = useState(false)
  const [noRecordsFound, setNoRecordsFound] = useState(false);


  const [activeIndex, setActiveIndex] = useState(null);

  useEffect(() => {
    getMethodList()
  }, []);

  useEffect(()=>{
    getIngredientList()
  },[itemIngredientList])

  useEffect(() => {
    if(fromDate && toDate){
        getKitList();
    }
  }, [fromDate, toDate, session, item, netIssueStatus])

  useEffect(()=>{
    if(activeIndex !== null){
      getKitItemsList()
    }
  },[kit,item,activeIndex])

  useEffect(() => {
    setSelectedRows([]);
    setSelectAll(false);
}, [itemIngredientList]);

  const handelFilterChange = async (from_date, to_date, session, item, requirementStatus, orderStatus, orderId, purchaseStatus, receiptStatus,issueStatus, ingredient) => {
        setActiveIndex(null)
        setFromDate(from_date);
        setToDate(to_date);
        // setSession(session);
        // setItem(item);
        // setNetIssueStatus(issueStatus)
        setItem(Array.isArray(item) ? item : item ? [item] : []);
        setNetIssueStatus(Array.isArray(issueStatus) ? issueStatus : issueStatus ? [issueStatus] : []);
        setSession(Array.isArray(session) ? session : session ? [session] : []);
  };

  const getIngredientList = async () => {
    const response = await axios.get(`${baseUrl}/ingredients/list?limit=all`);
    const existingIngredientIds = itemIngredientList?.map(item => item.ingredient_id) || [];
    const list = response.data.data.filter((item) => item.status == 1 && !existingIngredientIds.includes(item.id));
    setIngredientList(list);
  };

  const getMethodList = async () => {
    const response = await axios.get(
      `${baseUrl}/comman/list?table=method_master&condition=status=1`
    );
    setMethodList(response.data.data);
  };

  const getKitItemsList = async ()=>{
    setLoading(true)
    const kit = kitList.find((item, index) => index == activeIndex);
    const condition = `ird.menu_item_id='${kit.menu_item_id}' AND ird.date = '${kit.date}' AND ird.session='${kit.session}' AND ird.batch = '${kit.batch}' AND im.store = 3`;
    const RecipeDbData = await axios.get(`${baseUrl}/issue/ingredient_list?condition=${condition}`);
    const ingredientsList = RecipeDbData.data.data;
   
    if(ingredientsList.length > 0){
      const queries = ingredientsList.map(i => ({
        key: `ird_${i.ingredient_id}`,
        table: 'item_requirement_detail',
        condition: `date = '${kit.date}' AND session = '${kit.session}' AND menu_item_id = '${kit.menu_item_id}' AND batch = '${kit.batch}' AND ingredient_id = '${i.ingredient_id}'`
      }));
      const batchResponse = await axios.post(`${baseUrl}/comman/batch-list`, { queries });
      const bd = batchResponse.data.data;

      const updatedIngredientsList = ingredientsList.map(i => {
          const irdRows = bd[`ird_${i.ingredient_id}`] ?? [];

          let wastage;
          let gross_qty;
          let gross_issued_qty;
          let net_issued_qty;
          let issue_net_status;
          if(irdRows.length > 0){
            wastage = irdRows[0].wastage ?? 0;
            gross_qty = irdRows[0].gross_required_qty ?? 0;
            gross_issued_qty = irdRows[0].gross_issued_qty ?? 0;
            net_issued_qty = irdRows[0].net_issued_qty;
            issue_net_status = irdRows[0].issue_net_status;
          }else{
            wastage = parseFloat(i.wastage ?? 0);
            gross_qty = (parseFloat(i.required_qty) + (parseFloat(i.required_qty) * (wastage / 100))).toFixed(2);
          }

          const method = methodList.find((idx) => idx.id === i?.unit);
          const unitname = method?.name ?? "-";
          return {
            ...i,
            wastage: wastage,
            unitname: unitname,
            gross_required_qty: gross_qty,
            gross_issued_qty: gross_issued_qty,
            net_issued_qty: net_issued_qty ?? 0,
            issue_net_status: issue_net_status
          };
        });
      setItemIngredientList(updatedIngredientsList);
    }
    setLoading(false)
  }

  const getKitList = async () => {
        setLoading(true)
        setNoRecordsFound(false)
        const itemArr = Array.isArray(item) ? item : item ? [item] : [];
        const issueStatusArr = Array.isArray(netIssueStatus) ? netIssueStatus : netIssueStatus ? [netIssueStatus] : [];
        const sessionArr = Array.isArray(session) ? session : session ? [session] : [];
        const itemIds = itemArr.map(i => i.value).join(',');
        const issueStatusValues = issueStatusArr.map(s => s.value).join(',');
        const sessionValues = sessionArr.map(s => s.value).join(',');
        let condition = `requirement_status = 2 AND ingredient_added = 2`;
        if(fromDate == toDate){
            condition += ` AND date = '${fromDate}' `;
        }else if(fromDate && toDate){

          condition += ` AND (date >= '${fromDate}' AND date  <= '${toDate}') `;
        }
        // if(session?.value && session?.value != "undefined"){
        //   condition += ` AND session = '${session?.value}'`;
        // }
        if (sessionValues && sessionValues !== "undefined" && sessionValues.value !== "") {
          const sessionArr = sessionValues.split(',').map(id => `'${id}'`).join(',');
          condition += ` AND session IN (${sessionArr})`;
        }
        // if(item?.value && item?.value != "undefined"){
        //   condition += ` AND menu_item_id = '${item?.value}'`;
        // }
        if (itemIds && itemIds !== "undefined" && itemIds.value !== "") {
          const itemArr = itemIds.split(',').map(id => `'${id}'`).join(',');
          condition += ` AND menu_item_id IN (${itemArr})`;
        }
        // if(netIssueStatus?.value && netIssueStatus != 'undefined'){
        //   condition += ` AND issue_net_status = '${netIssueStatus?.value}'`
        // }
      if (issueStatusValues && issueStatusValues !== "undefined" && issueStatusValues !== "" && issueStatusValues !== "0") {
        const statusArr = issueStatusValues.split(',').map(s => `'${s}'`).join(',');
        condition += ` AND issue_net_status IN (${statusArr}) `;
      }
        const response = await axios.get(`${baseUrl}/comman/list?table=item_requirement_master&condition=${condition}`)
        const kitList = response.data.data;
        setKitList(kitList);
        setNoRecordsFound(kitList.length === 0);
        setLoading(false)
}
  const getRequirementList = async() => {
    const response = await axios.post(`${baseUrl}/issue/list`,
      { from_date : fromDate,
        to_date :toDate,
        session :session?.value,
        item : item?.value,
        issue_status: netIssueStatus?.value
       
    });
    setRequirementList(response.data.data);
  }

  
  const handleSubmit = async() => {
   
    const response = await axios.post(`${baseUrl}/requirement/status_update`,
      { selectedRows : selectedRows,
        status: 2});

      toast.success("Data successfully saved!");
      getRequirementList();
  };

//   const handleToggleSelect = (index) => {
//     const updatedSelectedRows = selectedRows.includes(requirementList[index])
//         ? selectedRows.filter(item => item !== requirementList[index]) // Deselect
//         : [...selectedRows, requirementList[index]]; // Select

//    setSelectedRows(updatedSelectedRows);
//    console.log("selected rows:", updatedSelectedRows)
    

// };
const handleToggleSelect = (index) => {
    const selectedItem = itemIngredientList[index];
    setSelectedRows(prev => 
        prev.includes(selectedItem)
            ? prev.filter(item => item !== selectedItem) // Deselect
            : [...prev, selectedItem] // Select
    );
};
// const handleSwitchSelectAll = () => {
//   if (selectAll) {
//       setSelectedRows([]);
//   } else {
//       setSelectedRows(requirementList.filter((item) => item.issue_status == 1)); // Select all rows
//   }
//   setSelectAll(!selectAll);
//   console.log("selected rows:", selectedRows);
//   console.log("select all:", selectAll);
// };

const handleSwitchSelectAll = () => {
    if (selectAll) {
        setSelectedRows([]);
    } else {
        // Select all rows that are not fully issued (status !== 3)
        setSelectedRows(itemIngredientList.filter(item => item.issue_net_status !== 3));
    }
    setSelectAll(!selectAll);
};

  const handleAddNewIngredientRow = ()=> {
    console.log("add new ingredient")
    setItemIngredientList([...itemIngredientList,{
      ingredient:'', 
      ingredient_obj:{},
      ingredient_id:null, 
      unit:null, 
      unitname:'', 
      wastage:0,
      gross_issued_qty:0, 
      // net_issued_qty:0, 
      gross_required_qty:0.01, 
      required_qty:0.01, 
      issue_status:1,
      isNew: true 
    }])
    // console.log("item ingredient list:",itemIngredientList)
  }

  const clearItem = () => {
    setActiveIndex(null)
    setSelectedItem(null);
    setItemIngredientList(null);
    getKitList()
  };

  const handleClick = (index) => {
    setActiveIndex(index === activeIndex ? null : index);
    setKit(kitList.find((item, i) => i == index))
  };
  

  const handleInputChange = (index) => (e) => {
    const { name, value } = e.target;
    
    setItemIngredientList((prevFormData) => {
      const updatedFormData = [...prevFormData];
      // if(name === "net_issued_qty"){
      //   const required_qty = updatedFormData[index].required_qty;
      //   const diff_qty = (value - required_qty).toFixed(3);
      //   updatedFormData[index] = { ...updatedFormData[index], [name]: value, diff_qty : diff_qty };
      // }else{
        updatedFormData[index] = { ...updatedFormData[index], [name]: value };
      // }
      return updatedFormData;
    });
  };

const handleSaveButton = async() => {
    try {
        const response = await axios.post(
            `${baseUrl}/issue_net/ingredient_save`,
            { 
                ingredientsList: itemIngredientList.map(item => {
                    // Keep original quantities and additional quantities
                    return {
                        ...item,
                        net_issued_qty: item.net_issued_qty || 0,
                        gross_issued_qty: item.gross_issued_qty || 0,
                        add_issue_net_qty: item.add_issue_net_qty || 0,
                        add_issue_gross_qty: item.add_issue_gross_qty || 0
                    };
                }),
                item: kit
            }
        );
        toast.success("Data saved successfully!");
        clearItem();
    } catch (error) {
        toast.error("Failed to save data. Please try again.");
    }
};

  const handleSave = async() => {

    if(selectedRows.length == 0){
      alert("Please select at least one row");
      setSelectedRows([]);
      return;
    }
    console.log(selectedRows);
    if(selectedRows.some(item => item.net_issued_qty == 0 && item.issue_net_status == 1)){
      alert("One or more items have an empty issue qty value.");
      setSelectedRows([]);
      return;
    }

    if(selectedRows.some(item => item.ingredient_id === null)){
      alert("One or more items have an empty ingredient value.");
      return
    }
    const issueCondition = selectedRows.some(item => 
      item.issue_status !== 3 && item.net_issued_qty > item.gross_issued_qty
    );

    if(issueCondition){
      const commonline = `ની નેટ ઇસ્યુ ક્યુએન્ટીટી ગ્રોસ ઇસ્યુ ક્યુએન્ટીટી કરતાં વધુ છે.`
      let confirmMessage = ``
      selectedRows.forEach(item => {
        if(item.issue_status !== 3 && item.net_issued_qty > item.gross_issued_qty){
          confirmMessage += `${item.ingredient} ${commonline}\n`
        }
      })

      confirmMessage += `શું તમે આગળ વધવા માંગો છો?`
      const confirmed = window.confirm(confirmMessage)
      if(!confirmed) return
    }
    try{
      const response = await axios.post(`${baseUrl}/issue_net/ingredient_update`,
        { ingredientList: itemIngredientList.map(item => { const { ...rest } = item; return rest;}),
          selectedRows : selectedRows.map(item => { const { ...rest } = item; return rest;}),
          item: kit});
          toast.success("Item added successfully!");  
          clearItem()
    }catch (error) {
      toast.error("Failed to add item. Please try again.");
    }
    
  }

    const handleAddButtonClick = (index, type) => {
    setItemIngredientList((prevFormData) => {
      const updatedFormData = [...prevFormData]
      const updatedItem = { ...updatedFormData[index] };

      if(type === 1){
        updatedItem.add_issue_net = true;
      }
      else if(type === 2){
        updatedItem.add_issue_gross = true;
      }
      updatedFormData[index] = updatedItem;
      console.log(updatedFormData[index])
      return updatedFormData

    });

  }

  const handleNewIngredientChange = (selectedOptions,index) => {
    // setNewIngredient((prev)=>({...prev,ingredient:ingredient}))
    const updatedList =   [...itemIngredientList]
    updatedList[index].ingredient_obj = selectedOptions
    updatedList[index].ingredient = selectedOptions.ingredient
    updatedList[index].ingredient_id = selectedOptions.value
    updatedList[index].unit = selectedOptions.unit
    updatedList[index].unitname = selectedOptions.unitname
    setItemIngredientList(updatedList)
  }

  const handleExport = async (e) => {
    e.preventDefault();
    try {
      // Prepare data for the worksheet
      const headerRow = ["Ingredient", "Net Issue Qty", "Gross Issue Qty", "Net Required Qty", "Gross Required Qty", "Issue Status"];

      const data = itemIngredientList.map(item => {
        console.log(item.ingredient);

        const status = item.issue_net_status == 3 ? "Issued" :
          item.issue_net_status == 2 ? "Partly Issue" : "Pending";
        return [
          item.ingredient,
          item.net_issued_qty,
          item.gross_issued_qty,
          item.required_qty,
          item.gross_required_qty,
          status
        ];
      });

      // Combine headers and data
      const worksheetData = [headerRow, ...data];

      // Create a worksheet
      const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);

      // Create a new workbook and append the worksheet
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Net Issue");

      // Generate Excel file buffer
      const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });

      // Save the file
      const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
      const kitName = kitList[activeIndex].kit_no.replace(/\//g, "_");
      saveAs(blob, `veg_store_net_${kitName}.xlsx`);
    } catch (error) {
      toast.error("Failed to export Excel. Please try again.");
    }
  };

  return (
    <div className="p-4">
      {loading && <Loader />}
      <div className="flex justify-between items-center py-4 px-6">
        <h1 className="text-lg sm:text-xl md:text-xl lg:text-xl xl:text-2xl font-bold">
          Issue (Net)
        </h1>

        <Toaster position="top-center" reverseOrder={false} />
      </div>
      <div className="relative shadow-md sm:rounded-lg">
        <VegRequirementFilter handleFilterChange={handelFilterChange} page="issue" />
      </div>
      {noRecordsFound && <NoRecordsFound />}
      <div>
        {kitList.map((item, index) => (
          <div key={index} className="border-b mt-4">
            <div
              className={`flex justify-between items-center p-4 cursor-pointer accordion-title border rounded
          ${item.issue_net_status == 1 ? 'bg-orange-400' :
                  (item.issue_net_status == 2 ? 'bg-yellow-400' : 'bg-green-400')}`}
              onClick={() => handleClick(index)}>
              <span>{`${item.kit_no} (${item.issue_net_status === 1 ? 'Pending issue' : (item.issue_net_status == 2 ? "Partly Issue" : "Issued")})`}</span>
              {index === activeIndex ? (
                <ChevronUpIcon className="w-6 h-6" />
              ) : (
                <ChevronDownIcon className="w-6 h-6" />
              )}
            </div>
            {index === activeIndex && (
              <div className="space-y-2 p-4">

                {/* Desktop Table View */}
                <div className="hidden md:block overflow-x-auto">
                  <table className="w-full mt-10 text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">
                    <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
                      <tr>
                        <th scope="col" className="px-2 py-1 border border-black text-center "><input type="checkbox" className="newrow checkboxAll" onChange={handleSwitchSelectAll} checked={selectAll} /></th>
                        <th scope="col" className="px-2 py-1 border border-black text-center ">શાકભાજીનું નામ</th>
                        <th scope="col" className="px-2 py-1 border border-black text-center " colSpan={2}>ઇસ્યુ</th>
                        <th scope="col" className="px-2 py-1 border border-black text-center " colSpan={2}>માંગેલ</th>
                        <th scope="col" className="px-2 py-1 border border-black text-center ">સ્ટેટસ</th>
                      </tr>
                      <tr>
                        <th scope="col" className="px-2 py-1 border border-black text-center "></th>
                        <th scope="col" className="px-2 py-1 border border-black text-center "></th>
                        <th scope="col" className="px-2 py-1 border border-black text-center ">નેટ વજન</th>
                        <th scope="col" className="px-2 py-1 border border-black text-center ">ગ્રોસ વજન</th>
                        <th scope="col" className="px-2 py-1 border border-black text-center ">નેટ વજન</th>
                        <th scope="col" className="px-2 py-1 border border-black text-center ">ગ્રોસ વજન</th>
                        <th scope="col" className="px-2 py-1 border border-black text-center "></th>
                      </tr>
                    </thead>
                    <tbody>
                      {itemIngredientList?.map((item, index) => (
                        <tr key={index} className="border border-black-b">
                          {(((item.issue_net_status !== 3) || (item.issue_net_status == 3 && item.add_issue_net)) && ((item.issue_net_status !== 2) || (item.issue_net_status === 2 && item.add_issue_net))) ?
                            (<td className="px-2 py-1 border border-black text-center"><input type="checkbox" checked={selectedRows.includes(item)} onChange={() => handleToggleSelect(index)} /></td>)
                            : (<td className="px-2 py-1 border border-black text-center"></td>)}
                          {item.isNew ? (<td className="px-2 py-1 border border-black text-center"><Select
                            // isMulti
                            classNamePrefix="select"
                            className='basic-multi-select'
                            value={item.ingredient_obj}
                            name="ingredient"
                            onChange={(selectedOptions) => handleNewIngredientChange(selectedOptions, index)}
                            options={ingredientList.map((item) => ({
                              value: item.id,
                              label: `${item.ingredient} (${item.eng_name})`,
                              unit: item.unit?.id,
                              unitname: item.unit?.name,
                              ingredient: `${item.ingredient}`,
                              eng_name: item.eng_name,
                            }))}
                            placeholder="Ingredient List"
                            filterOption={(option, inputValue) => {
                              return option.data.label.toLowerCase().includes(inputValue.toLowerCase());
                            }}
                            // Add these props to fix dropdown positioning
                            menuPortalTarget={document.body}
                            menuPosition="fixed"
                            styles={{
                              menuPortal: (base) => ({
                                ...base,
                                zIndex: 9999
                              }),
                              menu: (base) => ({
                                ...base,
                                zIndex: 9999
                              })
                            }}
                          /></td>) : <td className="px-2 py-1 border border-black text-center">{item.ingredient}</td>}

                          {/* <td className="px-2 py-1 border border-black text-center">{item.unitname}</td> */}
                          <td className="px-2 py-1 border border-black text-center"><input type="number"
                            id="net_issued_qty"
                            name="net_issued_qty"
                            disabled={item.issue_net_status === 3}
                            value={item?.net_issued_qty}
                            onChange={handleInputChange(index)}
                            onWheel={(e) => e.target.blur()}
                            onKeyDown={(e) => {
                              if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
                                e.preventDefault(); // Disable up and down arrow keys
                              }
                            }}
                            className="px-2 py-1 border rounded-md w-20 bg-orange-50"
                          />
                            {((item.issue_net_status === 1 || item.issue_net_status === 2 || item.issue_net_status === 3 || item.issue_net_status === 4) && item.net_issued_qty > 0) && (
                              <>
                                <button
                                  onClick={() => { handleAddButtonClick(index, 1) }}
                                  className='px-1 rounded border mx-2 scale-150 hover:bg-gray-300'
                                >
                                  &#x2b;
                                </button>
                                {item.add_issue_net && (
                                  <input
                                    type="number"
                                    id="add_issue_net_qty"
                                    name="add_issue_net_qty"
                                    value={item?.add_issue_net_qty ?? ''}
                                    onWheel={(e) => e.target.blur()}
                                    onChange={handleInputChange(index)}
                                    onKeyDown={(e) => {
                                      if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
                                        e.preventDefault(); // Disable up and down arrow keys
                                      }
                                    }}
                                    className="px-2 py-1 border rounded-md w-20 bg-orange-50"
                                  />
                                )}
                              </>
                            )}</td>
                          <td className="px-2 py-1 border border-black text-center"><input type="number"
                            id="gross_issued_qty"
                            name="gross_issued_qty"
                            // disabled={item.issue_net_status === 3}
                            value={item?.gross_issued_qty}
                            onChange={handleInputChange(index)}
                            onWheel={(e) => e.target.blur()}
                            onKeyDown={(e) => {
                              if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
                                e.preventDefault(); // Disable up and down arrow keys
                              }
                            }}
                            className="px-2 py-1 border rounded-md w-20 bg-orange-50"
                          />{((item.issue_net_status === 1 || item.issue_net_status === 2 || item.issue_net_status === 3 || item.issue_net_status === 4) && item.gross_issued_qty > 0) && (
                            <>
                              <button
                                onClick={() => { handleAddButtonClick(index, 2) }}
                                className='px-1 rounded border mx-2 scale-150 hover:bg-gray-300'
                              >
                                &#x2b;
                              </button>
                              {item.add_issue_gross && (
                                <input
                                  type="number"
                                  id="add_issue_gross_qty"
                                  name="add_issue_gross_qty"
                                  value={item?.add_issue_gross_qty ?? ''}
                                  onWheel={(e) => e.target.blur()}
                                  onChange={handleInputChange(index)}
                                  onKeyDown={(e) => {
                                    if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
                                      e.preventDefault(); // Disable up and down arrow keys
                                    }
                                  }}
                                  className="px-2 py-1 border rounded-md w-20 bg-orange-50"
                                />
                              )}
                            </>
                          )}</td>
                          <td className="px-2 py-1 border border-black text-center">{item?.required_qty}</td>
                          <td className="px-2 py-1 border border-black text-center">{item?.gross_required_qty}</td>
                          {/* <td className={`px-2 py-1 border border-black text-center ${item.diff_qty < 0 ? 'bg-red-500 text-black' : ''}`}>{item?.diff_qty}</td> */}
                          <td className="px-2 py-1 border border-black text-center">{item.issue_net_status == 3 ? "Issued" : (item.issue_net_status == 2 ? "Partly Issue" : "Pending")}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>

                {/* Mobile Card View */}
                <div className="md:hidden mt-4">
                  <div className="mb-4 p-3 bg-gray-100 rounded-lg">
                    <div className="flex items-center justify-between mb-2">
                      <span className="text-sm font-medium">Select All</span>
                      <input type="checkbox" className="newrow checkboxAll" onChange={handleSwitchSelectAll} checked={selectAll} />
                    </div>
                  </div>

                  <div className="space-y-4">
                    {itemIngredientList?.map((item, index) => (
                      <div key={index} className="border border-gray-300 rounded-lg p-4 bg-white shadow-sm">
                        {/* Header Row with Checkbox and Ingredient Name */}
                        <div className="flex items-center justify-between mb-3 pb-3 border-b">
                          <div className="flex-1">
                            {item.isNew ? (
                              <div className="w-full">
                                <Select
                                  classNamePrefix="select"
                                  className='basic-multi-select'
                                  value={item.ingredient_obj}
                                  name="ingredient"
                                  onChange={(selectedOptions) => handleNewIngredientChange(selectedOptions, index)}
                                  options={ingredientList.map((item) => ({
                                    value: item.id,
                                    label: `${item.ingredient} (${item.eng_name})`,
                                    unit: item.unit?.id,
                                    unitname: item.unit?.name,
                                    ingredient: `${item.ingredient}`,
                                    eng_name: item.eng_name,
                                  }))}
                                  placeholder="Ingredient List"
                                  filterOption={(option, inputValue) => {
                                    return option.data.label.toLowerCase().includes(inputValue.toLowerCase());
                                  }}
                                  menuPortalTarget={document.body}
                                  menuPosition="fixed"
                                  styles={{
                                    menuPortal: (base) => ({
                                      ...base,
                                      zIndex: 9999
                                    }),
                                    menu: (base) => ({
                                      ...base,
                                      zIndex: 9999
                                    })
                                  }}
                                />
                              </div>
                            ) : (
                              <span className="font-medium text-gray-900">{item.ingredient}</span>
                            )}
                          </div>
                          {(((item.issue_net_status !== 3) || (item.issue_net_status == 3 && item.add_issue_net)) && ((item.issue_net_status !== 2) || (item.issue_net_status === 2 && item.add_issue_net))) && (
                            <input type="checkbox" checked={selectedRows.includes(item)} onChange={() => handleToggleSelect(index)} className="ml-3" />
                          )}
                        </div>

                        {/* Status Badge */}
                        <div className="mb-3">
                          <span className={`inline-flex px-2 py-1 text-xs font-semibold rounded-full ${item.issue_net_status == 3 ? 'bg-green-100 text-green-800' :
                              (item.issue_net_status == 2 ? 'bg-yellow-100 text-yellow-800' : 'bg-orange-100 text-orange-800')
                            }`}>
                            {item.issue_net_status == 3 ? "Issued" : (item.issue_net_status == 2 ? "Partly Issue" : "Pending")}
                          </span>
                        </div>

                        {/* Issue Quantities */}
                        <div className="space-y-4 mb-3">
                          <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">ઇસ્યુ નેટ વજન</label>
                            <div className="flex items-center space-x-1">
                              <input
                                type="number"
                                id="net_issued_qty"
                                name="net_issued_qty"
                                disabled={item.issue_net_status === 3}
                                value={item?.net_issued_qty}
                                onChange={handleInputChange(index)}
                                onWheel={(e) => e.target.blur()}
                                onKeyDown={(e) => {
                                  if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
                                    e.preventDefault();
                                  }
                                }}
                                className="flex-1 min-w-0 px-2 py-1 border rounded-md bg-orange-50 text-sm"
                              />
                              {((item.issue_net_status === 1 || item.issue_net_status === 2 || item.issue_net_status === 3 || item.issue_net_status === 4) && item.net_issued_qty > 0) && (
                                <button
                                  onClick={() => { handleAddButtonClick(index, 1) }}
                                  className='flex-shrink-0 w-8 h-8 flex items-center justify-center rounded border hover:bg-gray-300 text-sm'
                                >
                                  &#x2b;
                                </button>
                              )}
                            </div>
                            {item.add_issue_net && (
                              <input
                                type="number"
                                id="add_issue_net_qty"
                                name="add_issue_net_qty"
                                value={item?.add_issue_net_qty ?? ''}
                                onWheel={(e) => e.target.blur()}
                                onChange={handleInputChange(index)}
                                onKeyDown={(e) => {
                                  if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
                                    e.preventDefault();
                                  }
                                }}
                                className="mt-2 w-full px-2 py-1 border rounded-md bg-orange-50 text-sm"
                                placeholder="Additional Net"
                              />
                            )}
                          </div>

                          <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">ઇસ્યુ ગ્રોસ વજન</label>
                            <div className="flex items-center space-x-1">
                              <input
                                type="number"
                                id="gross_issued_qty"
                                name="gross_issued_qty"
                                value={item?.gross_issued_qty}
                                onChange={handleInputChange(index)}
                                onWheel={(e) => e.target.blur()}
                                onKeyDown={(e) => {
                                  if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
                                    e.preventDefault();
                                  }
                                }}
                                className="flex-1 min-w-0 px-2 py-1 border rounded-md bg-orange-50 text-sm"
                              />
                              {((item.issue_net_status === 1 || item.issue_net_status === 2 || item.issue_net_status === 3 || item.issue_net_status === 4) && item.gross_issued_qty > 0) && (
                                <button
                                  onClick={() => { handleAddButtonClick(index, 2) }}
                                  className='flex-shrink-0 w-8 h-8 flex items-center justify-center rounded border hover:bg-gray-300 text-sm'
                                >
                                  &#x2b;
                                </button>
                              )}
                            </div>
                            {item.add_issue_gross && (
                              <input
                                type="number"
                                id="add_issue_gross_qty"
                                name="add_issue_gross_qty"
                                value={item?.add_issue_gross_qty ?? ''}
                                onWheel={(e) => e.target.blur()}
                                onChange={handleInputChange(index)}
                                onKeyDown={(e) => {
                                  if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
                                    e.preventDefault();
                                  }
                                }}
                                className="mt-2 w-full px-2 py-1 border rounded-md bg-orange-50 text-sm"
                                placeholder="Additional Gross"
                              />
                            )}
                          </div>
                        </div>

                        {/* Required Quantities */}
                        <div className="grid grid-cols-2 gap-4 pt-3 border-t">
                          <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">માંગેલ નેટ વજન</label>
                            <div className="px-2 py-1 bg-gray-50 rounded-md text-sm">
                              {item?.required_qty}
                            </div>
                          </div>
                          <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">માંગેલ ગ્રોસ વજન</label>
                            <div className="px-2 py-1 bg-gray-50 rounded-md text-sm">
                              {item?.gross_required_qty}
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>

                <div className="flex flex-col sm:flex-row items-center justify-end p-6 border-t border-solid border-blueGray-200 rounded-b space-y-2 sm:space-y-0 sm:space-x-2">
                  {kit.issue_net_status == 1 && (
                    <button
                      className="w-full sm:w-auto bg-emerald-500 text-white active:bg-emerald-600 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none ease-linear transition-all duration-150"
                      type="button"
                      onClick={() => handleSaveButton()}
                    >
                      Save
                    </button>
                  )}
                  {kit.issue_net_status !== 3 && (
                    <>
                      <button
                        className="w-full sm:w-auto bg-emerald-500 text-white active:bg-emerald-600 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none ease-linear transition-all duration-150"
                        type="button"
                        onClick={() => handleSave()}
                      >
                        Submit for Issue
                      </button>

                      <button
                        className="w-full sm:w-auto bg-emerald-500 text-white active:bg-emerald-600 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none ease-linear transition-all duration-150"
                        type="button"
                        disabled={kit.issue_net_status === 3}
                        onClick={() => { handleAddNewIngredientRow() }}
                      >
                        Add Ingredient
                      </button>
                    </>
                  )}
                  <button
                    onClick={handleExport}
                    className="w-full sm:w-auto px-4 py-2 bg-green-500 text-white rounded-md hover:bg-rose-600 focus:outline-none focus:ring focus:ring-rose-200">
                    Export
                  </button>
                </div>
              </div>)}
          </div>
        ))}
      </div>
    </div>
  );
}

export default IssueNetList;
